import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TemplateService } from '../../Services/TemplateService';
import { Subscription } from 'rxjs/Subscription';
import { FooterService } from '../../Services/FooterService';

@Component({
  selector: 'app-template-designer',
  templateUrl: './template-designer.component.html',
  styleUrls: ['./template-designer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TemplateDesignerComponent implements OnInit {

  
  private subscription: Subscription[] = [];
  designerSettings : any = {};
  SectionType = '';

  flexColumnsProperties = [
    {id:1,  value: 1, type: 'text', size: 'uik-sm-2', flex_size: 'w100'},
    {id:2,  value: 2, type: 'text', size: 'uik-sm-2', flex_size: 'w100'},
    {id:3,  value: 3, type: 'text', size: 'uik-sm-2', flex_size: 'w100'},
    {id:4,  value: 4, type: 'text', size: 'uik-sm-2', flex_size: 'w100'},
    {id:5,  value: 5, type: 'text', size: 'uik-sm-2', flex_size: 'w100'},
    {id:6,  value: 6, type: 'text', size: 'uik-sm-2', flex_size: 'w100'}
  ]
  flexColumns = 0;
  flexClass = '';
  flexAlignment = '';
  flexWrap = '';
  flexJustify = '';
  columnSizes = [];
  flexSizes = [];

  constructor(private _templateService : TemplateService, _footerService: FooterService) { 
    this.subscription.push(_templateService.designerSettings.subscribe(data=>{
      this.designerSettings = data;
    }));
    this.subscription.push(_footerService.columnSizes.subscribe(data=>{
      this.columnSizes = data;
    }))
    this.subscription.push(_footerService.flexSizes.subscribe(data=>{
      this.flexSizes = data;
    }))
  }

  ngOnInit() {
    
  }

  SetSectionType(value){
    this.SectionType = value;
  }
  SetFlexColumns(value){
    this.flexColumns = value;
  }
  SetFlexClass(value){
    this.flexClass = value;
  }
  SetFlexAlignment(value){
    this.flexAlignment = value;
  }
  SetFlexColumnsProperty(id, value){
    let index = this.flexColumnsProperties.findIndex(data=> data.id == id);
    this.flexColumnsProperties[index].type = value;
  }
  SetFlexColumnSize(id, value){
    let index = this.flexColumnsProperties.findIndex(data=> data.id == id);
    this.flexColumnsProperties[index].size = value;
  }
  SetListVisible(section_index, column_index, value : boolean){
    console.log(section_index, column_index, value);
	this.designerSettings.sections[section_index].columns[column_index].list_visible = value;
  }
  SetColumnContent(section_index, column_index, type){
	this.designerSettings.sections[section_index].columns[column_index].type = type;
  }
  AddColumn(section_index){
    console.log(section_index);
    this.designerSettings.sections[section_index].columns.push({
      id: this.designerSettings.sections[section_index].columns.length + 1,
      size: 'w100'
    });
    this._templateService.SetTemplate(this.designerSettings);
  }
  AddColumnForRow(section_index, id){
    // alert(id);
    console.log(section_index);
    this.designerSettings.sections.map(data=>{
      if(data.id == id){
        console.log(data);
        return data.columns.push({
          id: data.columns.length + 1,
          size: 'uik-sm-2'
        });
      }
    });
    // this.designerSettings.sections[section_index].columns.splice(section_index+1,0,{id: section_index+1, size:'uik-sm-1'});
    // console.log(this.designerSettings);
  }
  RemoveSection(section_index){
    this.designerSettings.sections.splice(section_index, 1);
  }
  RemoveColumn(section_index, column_index){
    this.designerSettings.sections[section_index].columns.splice(column_index, 1);
  }
  SetSectionFlexClass(section_index,value){
    this.designerSettings.sections[section_index].class = value;
  }
  SetSectionFlexAlignment(section_index,value){
    this.designerSettings.sections[section_index].alignment = value;
  }
  SetSectionFlexWrap(section_index,value){
    this.designerSettings.sections[section_index].wrap = value;
  }
  SetSectionFlexJustification(section_index,value){
    this.designerSettings.sections[section_index].justify = value;
  }
  IncreaseColumnSize(section_index,column_index){
    let size =  this.designerSettings.sections[section_index].columns[column_index].size;
    console.log(size);
    let index = this.columnSizes.findIndex(data=> data.value == size);
    if(this.columnSizes[index].name < 12){
      this.designerSettings.sections[section_index].columns[column_index].size = this.columnSizes[index + 1].value;
    }
  }
  DecreaseColumnSize(section_index,column_index){
    let size =  this.designerSettings.sections[section_index].columns[column_index].size;
    let index = this.columnSizes.findIndex(data=> data.value == size);
    if(this.columnSizes[index].name > 1){
      this.designerSettings.sections[section_index].columns[column_index].size = this.columnSizes[index - 1].value;
    }
  }

  IncreaseColumnSizeFlex(section_index,column_index){
    let size =  this.designerSettings.sections[section_index].columns[column_index].size;
    let index = this.flexSizes.findIndex(data=> data.value == size);
    if(this.flexSizes[index].name < 10){
      this.designerSettings.sections[section_index].columns[column_index].size = this.flexSizes[index + 1].value;
    }
  }
  DecreaseColumnSizeFlex(section_index,column_index){
    let size =  this.designerSettings.sections[section_index].columns[column_index].size;
    console.log(size);
    let index = this.flexSizes.findIndex(data=> data.value == size);
    if(this.flexSizes[index].name > 1){
      this.designerSettings.sections[section_index].columns[column_index].size = this.flexSizes[index - 1].value;
    }
  }
  DuplicateSection(section_index){
    let type = this.designerSettings.sections[section_index].type;
    if(type == 'flex'){
      let columns = [];
      for(let i = 0;i< this.designerSettings.sections[section_index].columns.length; i++ ){
        columns.push({
          type: this.designerSettings.sections[section_index].columns[i].type,
          size: this.designerSettings.sections[section_index].columns[i].size
        });
      }
     let schema = {
        id: this.designerSettings.sections.length + 1,
        type: type,
        class: this.designerSettings.sections[section_index].class,
        alignment: this.designerSettings.sections[section_index].alignment,
        columns: columns
      };
      this.designerSettings.sections.splice(section_index+1, 0,schema);
      this._templateService.SetTemplate(this.designerSettings);
    }
    if(type == 'row'){
      let columns = [];
      for(let i = 0;i< this.designerSettings.sections[section_index].columns.length; i++ ){
        columns.push({
          type: this.designerSettings.sections[section_index].columns[i].type,
          size: this.designerSettings.sections[section_index].columns[i].size
        });
      }
     let schema = {
        id: this.designerSettings.sections.length + 1,
        type: type,
        columns: columns
      };
      this.designerSettings.sections.splice(section_index+1, 0,schema);
      this._templateService.SetTemplate(this.designerSettings);
    }
  }
  CreateFlex(){
    let columns = [];
    for(let i = 0;i< this.flexColumns; i++ ){
      columns.push({
        id: this.flexColumnsProperties[i].id,
        size: this.flexColumnsProperties[i].flex_size
      });
    }
    this.designerSettings.sections.push({
      id: this.designerSettings.sections.length + 1,
      type: 'flex',
      class: this.flexClass,
      alignment: this.flexAlignment,   
      wrap: this.flexWrap,
      jusitfy: this.flexJustify,    
      columns: columns
    });
    console.log(this.designerSettings);
    this._templateService.SetTemplate(this.designerSettings);
  }
  CreateRow(){
    let columns = [];
      for(let i = 0;i< this.flexColumns; i++ ){
        columns.push({
          type: this.flexColumnsProperties[i].type,
          size: this.flexColumnsProperties[i].size
        });
      }
      this.designerSettings.sections.push({
        id: this.designerSettings.sections.length + 1,
        type: 'row',
        columns: columns
      });
      this._templateService.SetTemplate(this.designerSettings);
  }
  // Create(){
  //   if(this.SectionType == 'flex'){
  //     let columns = [];
  //     for(let i = 0;i< this.flexColumns; i++ ){
  //       columns.push({
  //         id: this.flexColumnsProperties[i].id
  //       });
  //     }
  //     this.designerSettings.sections.push({
  //       id: this.designerSettings.sections.length + 1,
  //       type: this.SectionType,
  //       class: this.flexClass,
  //       alignment: this.flexAlignment,       
  //       columns: columns
  //     });
  //     this._templateService.SetTemplate(this.designerSettings);
  //     console.log(this.designerSettings);
  //   }
  //   if(this.SectionType == 'row'){
  //     let columns = [];
  //     for(let i = 0;i< this.flexColumns; i++ ){
  //       columns.push({
  //         type: this.flexColumnsProperties[i].type,
  //         size: this.flexColumnsProperties[i].size
  //       });
  //     }
  //     this.designerSettings.sections.push({
  //       id: this.designerSettings.sections.length + 1,
  //       type: this.SectionType,
  //       columns: columns
  //     });
  //     this._templateService.SetTemplate(this.designerSettings);
  //     console.log(this.designerSettings);
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/app/template-designer/template-designer.component.ts